<template>
  <div class="wrapper">
    <div class="animated fadeIn">
      <b-row>
        <b-col>
          <b-card>
            <div slot="header">
              <strong>Update {{ filename }} file </strong> <small>Form</small>
            </div>
            <b-form>
              <b-row>
                <b-col sm="12">
                  <b-form-group>
                    <label for="filename" class="text-info"
                      >Filename: { no empty space allowed }</label
                    >
                    <b-form-input
                      type="text"
                      class="form-control"
                      id="filename"
                      placeholder="Filename: Ex: style.css"
                      v-model="filename"
                      required :disabled="lockFilename"
                    ></b-form-input>
                    <div
                      class="invalid-feedback d-block"
                      v-show="errors.filename"
                    >
                      {{ errors.filename }}
                    </div>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col sm="12">
                  <b-form-group>
                    <label for="#device" class="text-info">CSS code:</label>
                    <textarea
                      id="csscode"
                      rows="30"
                      cols="50"
                      class="form-control"
                      required="required"
                      v-model="css"
                    ></textarea>
                    <div class="invalid-feedback d-block" v-show="errors.css">
                      {{ errors.css }}
                    </div>
                    <br />
                  </b-form-group>
                  <b-form-group>
                    <b-button
                      class="mr-2"
                      type="submit"
                      size="md"
                      variant="danger"
                      @click.prevent="updateFile"
                      ><i class="fa fa-edit"></i> Update</b-button
                    >
                  </b-form-group>
                  <div class="invalid-feedback d-block" v-show="errors.general">
                    {{ errors.general }}
                  </div>
                </b-col>
              </b-row>
            </b-form>
          </b-card>
        </b-col>
      </b-row>
    </div>
    <b-modal id="no-title-edit-modal" ok-only ok-variant="secondary" ok-title="Close"><p>You cannot edit the filename. This file is in use by another banners. </p>
    <p><b-form-group>
                    <b-button
                      class="mr-2"
                      type="submit"
                      size="md"
                      variant="info"
                      @click.prevent="showWhereModal"
                      ><i class="fa fa-list"></i> View Banners</b-button
                    >
                  </b-form-group></p><p> Renaming will cause some serious problems!</p></b-modal>
    <b-modal size="lg" id="bannersInUse" ok-only ok-variant="secondary" ok-title="Close" :title="fileName" :hide-footer="hideFooter">
      <h1>CSS file in use by: </h1>
      <table class="table">
        <thead>
          <tr>
            <th scope="col">#</th>
            <th scope="col">Name</th>
            <th scope="col">Size</th>
            <th scope="col">Created:</th>
            <th scope="col">Edit Url:</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(banner, index) in isInUse" :key="banner._id">
            <th scope="row">{{index +1 }}</th>
            <td><a :href="generateHref(banner._id)" target="_BLANK">{{ banner.bannername }}</a></td>
            <td>{{ banner.size }}</td>
            <td>{{ $moment(banner.created_at).format('D/MM/YYYY') }}</td>
            <td><a :href="generateHref(banner._id)" target="_BLANK">/banners/edit/{{ banner._id }}</a></td>
          </tr>
        </tbody>
      </table>
      <button v-if="fName" class="btn btn-danger" @click.prevent="goAndEditFile(fName)"><i class="fa fa-edit"></i> Edit</button>&nbsp;&nbsp;
    </b-modal>
  </div>
</template>

<script>

export default {
  name: 'Create',
  data () {
    return {
      filename: '',
      oldfilename: '',
      css: '',
      errors: {},
      isInUse: [],
      available_files: {},
      lockFilename: false
    }
  },
  methods: {
    generateHref (id) {
      return `/banners/edit/${id}`
    },
    showWhereModal () {
      this.$bvModal.show('bannersInUse')
    },
    alertFileInUse () {
      if (this.lockFilename) {
        this.$bvModal.show('no-title-edit-modal')
      }
    },
    chechIfFileExist (filename) {
      // if the filename is unchanged, skip
      if (filename === this.$route.params.filename + '.css') {
        return false
      }
      // verify if file exist
      let available = []

      available = this.available_files.filter((file) => file.name === filename)
      if (available.length === 0) {
        return false
      } else {
        return true
      }
    },

    updateFile () {
      this.errors = {}

      const formData = new FormData()

      if (this.filename) {
        // check if there are empty spaces
        const emptySpaces = this.filename.split(' ')
        if (emptySpaces.length !== 1) {
          this.errors.filename = 'Empty spaces are not allowed!'
        } else {
          // check extension
          const checkExtension = this.filename.split('.')

          if (checkExtension.length === 2) {
            if ((checkExtension[1]).toLowerCase() === 'css') {
              if (!this.chechIfFileExist(this.filename)) {
                formData.append('filename', this.filename)
                formData.append('oldFilename', this.oldfilename)
              } else {
                this.errors.filename = 'Filename already in use. Choose another filename!'
              }
            } else {
              this.errors.filename = `Filename extension .css is required! Suggestion:  ${checkExtension[0]}.css`
            }
          } else {
            this.errors.filename = `Filename extension .css is required! Suggestion:  ${this.filename}.css`
          }
        }

        if (this.css) {
          formData.append('css', this.css)
        } else {
          this.errors.css = 'CSS code is required!'
        }

        if (Object.keys(this.errors).length === 0) {
          this.$http.patch(`${this.$api_url}/css/update`, formData)
            .then((data) => {
              if (data.data.message === 'file updated succesfully') {
                if (confirm('CSS file updatet! Navigate to the manage page?')) {
                  this.$router.push('/css/manage')
                }
              }
            }).catch((e) => {
              alert('Something went wrong. Please try again later!')
              this.errors.general = 'Something went wrong. Please try again!'
            })
        } else {
          this.errors.general = 'Check the required fields!'
        }
      } else {
        this.errors.filename = 'Filename is required!'
      }
    },
    loadCSSList () {
      this.$http.get(`${this.$api_url}/scandircss`).then((data) => {
        if (data) {
          this.available_files = data.data.data
        }
      })
    },
    loadFileContent () {
      const filename = this.$route.params.filename
      this.$http.get(`${this.$api_url}/css/update/${filename}`).then((data) => {
        this.filename = filename + '.css'
        this.css = data.data.data
      }).catch((e) => { alert(e) })
    },
    // prevent rename if file is in use
    checkIfFileIsInUse () {
      const formData = new FormData()
      formData.append('filename', this.$route.params.filename + '.css')
      this.$http.post(`${this.$api_url}/banner/checkIfCssFileIsInUse`, formData).then((data) => {
        this.isInUse = data.data.founded
      }).then((data) => {
        if ((this.isInUse).length === 0) {
          this.lockFilename = false
        } else {
          this.lockFilename = true
          this.alertFileInUse()
        }
      }).catch((e) => {
        // do nothing
        this.lockFilename = true
        this.alertFileInUse()
      })
    }
  },
  created () {
    this.oldfilename = this.$route.params.filename + '.css'
    this.loadFileContent()
    this.loadCSSList()
    this.checkIfFileIsInUse()
  }
}
</script>

<style scoped>
xmp {
  overflow: auto;
}
</style>
